import { AppConfig } from 'AppConfig';

export const setSmartCardsReportsSessionDefaults = () => {
  sessionStorage.setItem('reportsType', AppConfig.REPORT_CATEGORY.SMART.code);
  sessionStorage.setItem('sortBy', 'needs_attention');
  sessionStorage.setItem('scrollToReports', 'true');
};
